import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationBillableConceptCreateRequest, ConfigurationBillableConceptPatchInBatchRequest, ConfigurationBillableConceptResponse } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { ConfigurationBillableConceptGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/groups-of-concepts/services/configuration-billable-concept-group.dto'

class ConfigurationBillableConceptService {
    async create(request: ConfigurationBillableConceptCreateRequest): Promise<ConfigurationBillableConceptResponse> {
        const response = await axios.post<ConfigurationBillableConceptResponse>(`/configuration/billableConcepts`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<ConfigurationBillableConceptResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationBillableConceptResponse>>(`/configuration/billableConcepts`, { ...filterModel }, { params })
        return response.data
    }

    async get(billableConceptId: number): Promise<ConfigurationBillableConceptResponse> {
        const response = await axios.get<ConfigurationBillableConceptResponse>(`/configuration/billableConcepts/${billableConceptId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/billableConcepts/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationBillableConceptPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/billableConcepts/batch`, request)
        return response.data
    }

    async findAllConceptGroups(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined): Promise<IResponseAgGrid<ConfigurationBillableConceptGroupResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationBillableConceptGroupResponse>>(`/configuration/billableConceptGroups`, { ...filterModel }, { params })
        return response.data
    }
}

export const configurationBillableConceptService = new ConfigurationBillableConceptService()
